import request from '@/utils/request';

// 登录
export function Login(data) {
    return request({
        url: '/cognition/login',
        method: 'POST',
        data
    });
}

